<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="socials__background module__background"
        ></app-modulebackground>
        <div
            class="socials__container module__container"
            v-bind:class="{
                container__boxed: [1, 2].includes(module.layout.type),
                'container__boxed--half': [3].includes(module.layout.type)
            }"
        >
            <div class="socials__inner module__inner">
                <div class="socials__inner--main module__inner--main">
                    <div class="socials__inner-row module__inner-row">
                        <div class="socials__inner-col module__inner-col">
                            <div class="socials__content-block module__content-block">
                                <div
                                    class="socials__content-block--left module__content-block--left"
                                    v-bind:class="{
                                        'col__width--full': [1, 3].includes(module.layout.type),
                                        'col__width--half': [2].includes(module.layout.type)
                                    }"
                                    v-if="
                                        module.data.title ||
                                            module.data.subtitle ||
                                            ([2].includes(module.layout.type) &&
                                                ((module.data.link && module.data.link.active) ||
                                                    (module.data.link2 &&
                                                        module.data.link2.active) ||
                                                    (module.data.link3 &&
                                                        module.data.link3.active)))
                                    "
                                >
                                    <div
                                        class="socials__inner-row module__inner-row"
                                        v-if="module.data.title || module.data.subtitle"
                                    >
                                        <div class="socials__inner-col module__inner-col">
                                            <div class="socials__header module__header">
                                                <h2
                                                    class="socials__title module__title font-h2 color-h2"
                                                    v-if="module.data.title"
                                                    v-html="module.data.title"
                                                ></h2>
                                                <h3
                                                    class="socials__subtitle module__subtitle font-h3 color-h3"
                                                    v-if="module.data.subtitle"
                                                    v-html="module.data.subtitle"
                                                ></h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="socials__inner-row module__inner-row"
                                        v-if="
                                            [2].includes(module.layout.type) &&
                                                ((module.data.link && module.data.link.active) ||
                                                    (module.data.link2 &&
                                                        module.data.link2.active) ||
                                                    (module.data.link3 && module.data.link3.active))
                                        "
                                    >
                                        <div class="socials__inner-col module__inner-col">
                                            <div class="socials__cta module__cta">
                                                <app-modulebutton
                                                    v-if="[2].includes(module.layout.type)"
                                                    :data="module.data.link"
                                                    :custom-class="
                                                        'socials__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                    "
                                                ></app-modulebutton>
                                                <app-modulebutton
                                                    v-if="[2].includes(module.layout.type)"
                                                    :data="module.data.link2"
                                                    :custom-class="
                                                        'socials__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                    "
                                                ></app-modulebutton>
                                                <app-modulebutton
                                                    v-if="[2].includes(module.layout.type)"
                                                    :data="module.data.link3"
                                                    :custom-class="
                                                        'socials__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                    "
                                                ></app-modulebutton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="socials__content-block--right module__content-block--right"
                                    v-bind:class="{
                                        'col__width--full': [1, 3].includes(module.layout.type),
                                        'col__width--half': [2].includes(module.layout.type)
                                    }"
                                    v-if="items && Array.isArray(items) && items.length > 0"
                                >
                                    <div class="socials__inner-row module__inner-row">
                                        <div class="socials__inner-col module__inner-col">
                                            <ul class="socials__list module__list">
                                                <li
                                                    class="socials__list-item module__list-item"
                                                    v-bind:class="{
                                                        'col__width--one-eighth': [1].includes(
                                                            module.layout.type
                                                        ),
                                                        'col__width--one-third': [2].includes(
                                                            module.layout.type
                                                        ),
                                                        'col__width--one-quarter': [3].includes(
                                                            module.layout.type
                                                        )
                                                    }"
                                                    v-for="items__value in items"
                                                    v-bind:key="items__value.id"
                                                    :data-preset-id="items__value.preset_id"
                                                >
                                                    <div
                                                        class="socials__teaser-box"
                                                        v-bind:class="{
                                                            'module__teaser-box--horizontal': [
                                                                1,
                                                                2,
                                                                3
                                                            ].includes(module.layout.type)
                                                        }"
                                                    >
                                                        <a
                                                            :href="items__value.data.link"
                                                            class="module__link d-inline-block"
                                                            target="_blank"
                                                        >
                                                            <app-moduleicon
                                                                :data="items__value.data.icon"
                                                                :custom-class="
                                                                    'socials__list-icon module__icon'
                                                                "
                                                            ></app-moduleicon>
                                                            <span
                                                                class="socials__teaser-label module__label font-bold color-p"
                                                                >{{ items__value.data.name }}</span
                                                            >
                                                        </a>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="socials__inner-row module__inner-row"
                        v-if="
                            [1, 3].includes(module.layout.type) &&
                                ((module.data.link && module.data.link.active) ||
                                    (module.data.link2 && module.data.link2.active) ||
                                    (module.data.link3 && module.data.link3.active))
                        "
                    >
                        <div class="socials__inner-col module__inner-col">
                            <div class="socials__cta module__cta">
                                <app-modulebutton
                                    v-if="[1, 3].includes(module.layout.type)"
                                    :data="module.data.link"
                                    :custom-class="
                                        'socials__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    v-if="[1, 3].includes(module.layout.type)"
                                    :data="module.data.link2"
                                    :custom-class="
                                        'socials__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    v-if="[1, 3].includes(module.layout.type)"
                                    :data="module.data.link3"
                                    :custom-class="
                                        'socials__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleIcon from '@/components/assorted/ModuleIcon';
import ModuleBackground from '@/components/assorted/ModuleBackground';

export default {
    data() {
        return {};
    },
    components: {
        'app-modulebutton': ModuleButton,
        'app-moduleicon': ModuleIcon,
        'app-modulebackground': ModuleBackground
    },
    methods: {},
    computed: {
        ...mapGetters(['getListItems']),
        items() {
            return this.getListItems('deha.user.misc.socials');
        }
    },
    props: {
        module: Object
    },
    mounted() {}
};
</script>
